<template>
    <el-container v-loading="$store.state.aws_loading"
    element-loading-background="rgba(0, 0, 0, 0.6)">
      
      <el-aside v-if="pc_app=='pc' " width="320">
        <Sidebar/>
      </el-aside>

      <el-aside v-if="pc_app == 'app'" width="320">
        <!-- <button @click="drawer=!drawer ">11</button> -->
        <!-- 抽屉 弹框 -->
        <el-drawer
          :with-header="false"
          size="320px"
          :visible.sync="drawer"
          direction="ltr"
        >
          <Sidebar />
        </el-drawer>
      </el-aside>
      
      <el-container>
        <el-header height="80px">
          <Header/>
        </el-header>
        <el-main ref="body_box">
          <router-view/>
        </el-main>
      </el-container>
  </el-container>
</template>

<script>
export default {
  components: {
    Header: () => import("./components/header.vue"),
    Sidebar: () => import("./components/sidebar.vue"),
  },
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      drawer: false,
    };
  },
  created() {
    
  },
  mounted() {
    this.bus.$on('app_sidebar_open',()=>{
      this.drawer=true;
    });

    // 路由切换 返回顶部
    this.$router.afterEach((to, from, next) => {
      to; from; next;
      this.$nextTick(() => {
        if(this.$refs&&this.$refs.body_box&&this.$refs.body_box.$el&&this.$refs.body_box.$el.scrollTop){
          this.$refs.body_box.$el.scrollTop = 0;
          // console.log(this.$refs.body_box.$el.scrollTop);
        }
      })     
    });

    // 页面 滚动最底部
    this.bus.$on('scroll_set',()=>{
      this.$refs.body_box.$el.scrollTop = this.$refs.body_box.$el.scrollHeight;
    });

    // 页面 滚动一定距离
    this.bus.$on('scroll_set_num',(v)=>{
      this.$refs.body_box.$el.scrollTop = v;
    });

  },
  destroyed() {
    this.bus.$off('app_sidebar_open');
    this.bus.$off('scroll_set');
    this.bus.$off('scroll_set_num');
  },
  watch:{
    $route(){
      this.drawer=false;
    }
  },
  methods: {

  },
};
</script>

<style scoped>
.el-header {
  padding: 0 !important;
}
.el-main {
  height: calc(100vh - 80px);
  overflow: auto;
  /* overflow-y: hidden; */
  background: #191E29;
  color: #fff;
  box-sizing: border-box;
  padding: 40px;
}
.el-main::-webkit-scrollbar {
  /* width: 8px; */
  width: 5px;
}
.el-main::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00c18e;
}

/* 手机端 */
@media screen and (max-width: 850px) {
  .el-main{
    overflow-y: auto;
    padding: 20px;
  }
}
</style>
